import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useIntl } from 'react-intl';

import IntlMessages from '@src/util/IntlMessages';

import styles from './styles.module.less';

export interface WorkJourneyMonthSidebarIssue {
  type: string;
  count: number;
}

interface WorkJourneyMonthSidebarProps {
  month: number;
  year: number;
  issues: WorkJourneyMonthSidebarIssue[];
  issueTypes: string[];
  issueLabelPrefix: string;
  onPreviousMonth: () => void;
  onNextMonth: () => void;
}

const ISSUE_DOT_COLORS: Record<string, string> = {
  below_minimum: styles.dotCritical,
  scheduled_absences: styles.dotWarning,
  rejections: styles.dotRejections,
  staffing_shortage: styles.dotCritical,
  on_track: styles.dotSuccess,
  holiday: styles.dotHoliday,
};

export const WorkJourneyMonthSidebar = ({
  month,
  year,
  issues,
  issueTypes,
  issueLabelPrefix,
  onPreviousMonth,
  onNextMonth,
}: WorkJourneyMonthSidebarProps) => {
  const intl = useIntl();

  const monthLabel = intl.formatDate(new Date(year, month - 1, 1), {
    month: 'long',
    year: 'numeric',
  });

  const getIssueCount = (type: string) => issues.find(issue => issue.type === type)?.count ?? 0;

  return (
    <aside>
      <div className={styles.monthNavigator}>
        <Button
          type="text"
          className={styles.navButton}
          icon={<LeftOutlined />}
          onClick={onPreviousMonth}
          aria-label="Previous month"
        />
        <span className={styles.monthLabel}>{monthLabel}</span>
        <Button
          type="text"
          className={styles.navButton}
          icon={<RightOutlined />}
          onClick={onNextMonth}
          aria-label="Next month"
        />
      </div>

      <div className={styles.summaryCard}>
        <h4 className={styles.summaryTitle}>
          <IntlMessages id="workJourney.management.journeys.sidebar.daysWith" />
        </h4>
        <ul className={styles.issueList}>
          {issueTypes.map(type => (
            <li key={type} className={styles.issueItem}>
              <span className={`${styles.dot} ${ISSUE_DOT_COLORS[type] ?? ''}`} />
              <span className={styles.issueLabel}>
                <IntlMessages id={`${issueLabelPrefix}.${type}`} />
              </span>
              <span className={styles.issueCount}>{getIssueCount(type)}</span>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
};
